import * as React from 'react';
import cn from 'clsx';
import { TInputType } from '@cian/ui-kit/input/types';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as styles from './styles.css';

import { InfoText } from '../InfoText';
import { FormInputsLayout } from '../../../FormInputsLayout';

export interface IPhoneFieldProps {
  value: string;
  isValid: boolean;
  errorMessage: string;
  inputName: string;
  placeholder?: string | null;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

/** Поле телефона с кнопкой "Дальше" используется в объединенном шаге phone, когда следом идет подтверждение телефона */
export const PhoneField: React.FC<React.PropsWithChildren<IPhoneFieldProps>> = ({
  value,
  onChange,
  errorMessage,
  isValid,
  placeholder,
  inputName,
}) => {
  const deviceType = useDeviceType();

  const containerClassNames = React.useMemo(
    () =>
      cn(styles['container'], {
        [styles['mobile']]: deviceType === 'phone',
      }),
    [deviceType],
  );

  return (
    <div className={containerClassNames}>
      <FormInputsLayout
        InputProps={{
          invalid: !isValid,
          type: 'tel' as TInputType,
          placeholder: /* istanbul ignore next */ placeholder || '',
          onChange,
          errorMessage,
          value,
          name: inputName,
        }}
        fullwidth
      />
      <div className={styles['info']}>
        <InfoText />
      </div>
    </div>
  );
};

PhoneField.displayName = 'PhoneField';
